
import React from 'react';
import { useSupabaseAuth } from '@/hooks/auth';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PWASettings } from '@/components/settings/PWASettings';
import { Separator } from '@/components/ui/separator';

const Settings: React.FC = () => {
  const { user, profile } = useSupabaseAuth();

  if (!user) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Card>
          <CardHeader>
            <CardTitle>Settings</CardTitle>
          </CardHeader>
          <CardContent>
            <p>Please sign in to view your settings.</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8 space-y-8">
      <div>
        <h1 className="text-3xl font-bold">Settings</h1>
        <p className="text-muted-foreground">
          Manage your account preferences and app settings
        </p>
      </div>

      {/* User Profile Settings */}
      <Card>
        <CardHeader>
          <CardTitle>Profile Information</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium">User ID</label>
              <p className="text-sm text-muted-foreground">{user.id}</p>
            </div>
            <div>
              <label className="text-sm font-medium">Email</label>
              <p className="text-sm text-muted-foreground">{user.email}</p>
            </div>
            {profile && (
              <>
                <div>
                  <label className="text-sm font-medium">Name</label>
                  <p className="text-sm text-muted-foreground">{profile.name}</p>
                </div>
                <div>
                  <label className="text-sm font-medium">Avatar URL</label>
                  <p className="text-sm text-muted-foreground truncate">{profile.avatar_url}</p>
                </div>
              </>
            )}
          </div>
        </CardContent>
      </Card>

      <Separator />

      {/* PWA Settings */}
      <PWASettings />
    </div>
  );
};

export default Settings;
